/*
 * - Definitions for Lookup queries
 */

import PlssService from './service';
import { Geometry, PlssResponse } from './types';

export const PLSS_QUERY_KEYS = {
  GET_PLSS: 'GET_PLSS',
};

export class PlssQueries {
  public static readonly getPlss = async (geometry: Geometry): Promise<PlssResponse> => {
    const data = await PlssService.getPlss(geometry);
    return data;
  };
}
